import React, { useEffect, useRef, useState } from 'react'

// redux
import { connect } from "react-redux";

// react router
import { Link } from 'react-router-dom';

// icons
import {
    FiSearch,
    FiUser,
    FiShoppingCart
} from "react-icons/fi";
import { MdLogout } from "react-icons/md";
import { HiUser, HiShoppingCart, HiUserAdd } from "react-icons/hi";

// modal
import ModalSearch from './Modals/ModalSearch';

// helpers | common
import {
    globalLogout,
} from "utlis/helpers/Common/CommonHelperFunctions";

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';


function RightSec(props) {
    // props
    const {
        cartDetails,
        currentUser
    } = props

    // states
    const [searchModalVisibility, setSearchModalVisibility] = useState(false)

    // states
    const [isDropdownOpened, setIsDropdownOpened] = useState(false)

    // refs
    const searchRef = useRef(null)

    // HANDLE SEARCH MODAL CLOSE
    const handleSearchModalClose = () => {
        setSearchModalVisibility(false)
    }

    // HANDLE SEARCH MODAL OPEN
    const handleSearchModalOpen = () => {
        searchRef?.current?.focus()
    }

    // user logouts
    const handleUserLogout = ev => {
        ev.preventDefault()

        const confirm = window.confirm("Are you sure you want to logout?")

        if (confirm) {
            // enable global loading
            setGlobalLoading(true)

            // global logout function
            globalLogout()

            // disabling global loading
            setGlobalLoading(true)
        }
    }

    return (
        <div className='right-sec'>
            <div className="d-flex flex-wrap align-items-center justify-content-end">
                {/* item */}
                <div 
                    className="item search d-none d-lg-flex align-items-center cursor-pointer st-text-primary" 
                    onClick={() => setSearchModalVisibility(true)}
                    title="Search">
                    <FiSearch fontSize={18} />
                </div>
                <div 
                    className="item search for-mobile d-lg-none d-flex align-items-center cursor-pointer st-text-primary me-2" 
                    onClick={() => setSearchModalVisibility(true)}
                    title="Search">
                    <FiSearch fontSize={20} />
                </div>

                {
                    currentUser?.firstName ? (
                        <div 
                            className="dd-container position-relative" 
                            onMouseEnter={() => setIsDropdownOpened(true)} 
                            onMouseLeave={() => setIsDropdownOpened(false)}>
                            {/* item */}
                            <a 
                                href="/" 
                                className="item login d-none d-lg-flex align-items-center cursor-pointer st-text-primary text-decoration-none"
                                onClick={ev => ev.preventDefault()}>
                                <span className='st-fw-600'>Hi {currentUser?.firstName}</span>
                            </a>
                            {/* for mobile */}
                            <a 
                                href="/" 
                                className="item login for-mobile d-lg-none d-flex align-items-center cursor-pointer st-text-primary text-decoration-none me-2"
                                onMouseEnter={() => setIsDropdownOpened(true)}
                                onMouseLeave={() => setIsDropdownOpened(false)}
                                onClick={ev => ev.preventDefault()}>
                                <FiUser fontSize={20} />
                            </a>

                            {
                                /* dropdown */
                                isDropdownOpened ? (
                                    <div className="st-dd">
                                        <div className="st-dd-inner">
                                            {/* link */}
                                            <Link to="/account" className="st-dd-link text-decoration-none d-flex align-items-center">
                                                <HiUser className="st-fs-13" />
                                                <span className="ms-2 st-fs-13 st-fw-600">My Account</span>
                                            </Link>

                                            <a href="/" className="st-dd-link text-decoration-none d-flex align-items-center" onClick={handleUserLogout}>
                                                <MdLogout className="st-fs-14" />
                                                <span className="ms-2 st-fs-13 st-fw-600">Logout</span>
                                            </a>
                                        </div>
                                    </div>
                                ) : null
                            }
                        </div>
                    ) : (
                        <div 
                            className="dd-container position-relative" 
                            onMouseEnter={() => setIsDropdownOpened(true)} 
                            onMouseLeave={() => setIsDropdownOpened(false)}>
                            {/* item */}
                            <a 
                                href="/" 
                                className="item login d-none d-lg-flex align-items-center cursor-pointer st-text-primary text-decoration-none"
                                onClick={ev => ev.preventDefault()}>
                                <span className='st-fw-600'>Login</span>
                            </a>
                            {/* for mobile */}
                            <a 
                                href="/" 
                                className="item login for-mobile d-lg-none d-flex align-items-center cursor-pointer st-text-primary text-decoration-none me-2"
                                onClick={ev => ev.preventDefault()}>
                                <FiUser fontSize={20} />
                            </a>

                            {
                                /* dropdown */
                                isDropdownOpened ? (
                                    <div className="st-dd">
                                        <div className="st-dd-inner">
                                            {/* link */}
                                            <Link to="/login" className="st-dd-link text-decoration-none d-flex align-items-center" onClick={() => setIsDropdownOpened(false)}>
                                                <HiUser fontSize={16} />
                                                <span className="ms-2 st-fs-13 st-fw-600">Sign In</span>
                                            </Link>
                                            {/* link */}
                                            <Link to="/register" className="st-dd-link text-decoration-none d-flex align-items-center" onClick={() => setIsDropdownOpened(false)}>
                                                <HiUserAdd fontSize={17} />
                                                <span className="ms-2 st-fs-13 st-fw-600">Register</span>
                                            </Link>
                                        </div>
                                    </div>
                                ) : null
                            }
                        </div>
                    )
                }

                {/* item */}
                <Link to="/cart" className="item cart d-none d-lg-flex align-items-center cursor-pointer st-text-primary text-decoration-none">                    
                    <span className='st-fw-600'>Cart ({cartDetails?.cart_qty ?? 0})</span>
                </Link>
                {/* for mobile */}
                <Link to="/cart" className="item cart for-mobile d-lg-none d-flex align-items-center cursor-pointer st-text-primary text-decoration-none">                    
                    <FiShoppingCart fontSize={20} />
                    <span className="badge d-none">({cartDetails?.cart_qty ?? 0})</span>
                </Link>
            </div>

            {/* modals */}
            <ModalSearch
                searchModalVisibility={searchModalVisibility}
                handleSearchModalClose={handleSearchModalClose}
                handleSearchModalOpen={handleSearchModalOpen}

                searchRef={searchRef}
            />
        </div>
    )
}


const getDataFromStore = (state) => {
    return {
        cartDetails: state.cart.cartDetails,
        currentUser: state.auth.currentUser,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(RightSec);